import { render, staticRenderFns } from "./teachingRoom.vue?vue&type=template&id=bcec0452&scoped=true&"
import script from "./teachingRoom.vue?vue&type=script&lang=js&"
export * from "./teachingRoom.vue?vue&type=script&lang=js&"
import style0 from "./teachingRoom.vue?vue&type=style&index=0&id=bcec0452&lang=less&scoped=true&"
import style1 from "./teachingRoom.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcec0452",
  null
  
)

export default component.exports